import { createAction } from "@reduxjs/toolkit";

export const updateDashboardDate = createAction<{ dashboardDate: string }>('dashboard/updateDashboardDate');